import { makeStyles } from "@saleor/macaw-ui";

export const useStyles = makeStyles(
  () => ({
    root: {
      textDecoration: "none",
    },
  }),
  { name: "InternalLink" },
);
